<!-- 电视大屏数据滚动 2010-7-20 zs -->
<template>
    <div class="BSmainWrap" v-loading.fullscreen.lock="fullscreenLoading"  element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <div class="wrap">
            <div>
                <dashBoard class="compose"></dashBoard>
            </div>
            <div>
                <cd class="compose"></cd>
            </div>
            <div>
                <iframe id="ep" src="/tv/EP001" frameborder="0"></iframe>
            </div>
            <div>
                <ef class="compose"></ef>
            </div>
            <div class="imgWrap">
                <img id="granfanaWrap1" src="">
            </div>
            <div >
                <pfa class="compose"></pfa>
            </div>
            <div class="imgWrap">
                 <img id="granfanaWrap2" src="">
            </div>
            <div >
                <er class="compose"></er>
            </div>
             <div >
                <er2 class="compose"></er2>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import dashBoard from "@/components/dashBoard.vue"
import cd from "@/components/CD001.vue"
import ef from "@/components/EF001.vue"
import pfa from "@/components/PFA001.vue"
import er from "@/components/ER002.vue"
import er2 from "@/components/ER002-2.vue"

export default {
  name: 'tv',
  components: {
    dashBoard,
    cd,
    ef,
    pfa,
    er,
    er2
  },
  data(){
    return{
      rollIndex: 1,
      granfanaimgUrl: [],
      fullscreenLoading: false,
      //   定时器
      timer1: '',
      timer2: '',
      timer3: ''
    }
  },
  mounted() {
    
    this.getId()
  },
  destroyed(){
    clearTimeout(this.timer1)  
    clearTimeout(this.timer2)
    clearInterval(this.timer3)
  },
  methods:{
    getId(){
      let _this = this
      this.fullscreenLoading = true
      this.axios({
        method: 'get',
        url: '/url/getBigscreenMachine'
      }).then(function(res){
        if(res.data.success === 'false'){
            _this.$message({
                duration: 5000,
                message: res.data.msg,
                type: 'error'
                })
            _this.$router.push({path:'/tv/login'})
        }else{
            _this.timer3=setInterval(()=>{
                _this.getUrl()
            }, 10000); 
            _this.firstLoading()
        }
      })
    },
    //   获取图片地址url
    getUrl(){
        this.axios({
            method: 'GET',
            url: '/url/GrafanaDashBoard/list',
        }).then(function(res){
            if (res.data.success === 'true'){
                $('#granfanaWrap1').attr('src',res.data.img[1])
                $('#granfanaWrap2').attr('src',res.data.img[0])
            }
        })
    },
    //   八秒定时器
    timer8s(){
        let _this = this
        clearTimeout(_this.timer2)
        _this.timer1 = setTimeout(function(){
            _this.roll()
            _this.timer15s()
        },8000)
    },
    //    15秒定时器
    timer15s(){
        let _this = this
        clearTimeout(_this.timer1)
        _this.timer2 = setTimeout(function(){
            _this.roll()
            _this.timer8s()
        },15000)
    },
    // 滚动
    roll(){
        if (this.rollIndex>=9){
            this.rollIndex=0
            $('.wrap').css({
              'top': 0
            })
        }
        $('.wrap').css({
            'top': this.rollIndex*-100+'%'
        })
        
    //    $('.wrap div').show()
    //     $('.wrap div').eq(this.rollIndex).hide()
        this.rollIndex+=1
    },
    firstLoading(){
        let _this =this
        this.fullscreenLoading = true
        
        setTimeout(function(){
            _this.timer8s()
            _this.fullscreenLoading = false
        },10000)
    }
  }
}
</script>

<style scoped>
    html,body{
        margin: 0;
        padding: 0;
        height: 100%;
    }
    .BSmainWrap{
        height: 100%;
        overflow: hidden;
    }
    .wrap{
        height: 900%;
        position: relative;
        top: 0;
        left: 0;
        /* height: 100%; */
    }
    .wrap div{
        height: 11.111%;
        /* height: 100%;
        width: 100%;
        position: absolute;
        top:0;
        left: 0; */
    }
    iframe,.compose{
        width: 100%;
        height: 100%!important;
    }
    .imgWrap{
        display: flex;
        align-items: center;
    }
    img{
        width: 100%;
    }
</style>
